import { useState } from "react";
import { Check, Copy } from "lucide-react";
import "./success_screen.css";

const SuccessScreen = ({ payStatus, name, email, password }) => {
  const [copiedField, setCopiedField] = useState(null);

  const statusMap = {
    PENDING: "⏳ Pendente",
    CONFIRMED: "✅ Confirmado",
  };

  const copyToClipboard = async (field, value) => {
    await navigator.clipboard.writeText(value);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 1500);
  };

  return (
    <div className="succ">
      <h3 className="succ-title">
        🎉 Parabéns pela sua assinatura no <span>Domínio Elétrico</span>
      </h3>

      <p
        className={`succ-status ${
          payStatus === "CONFIRMED" ? "confirmed" : "pending"
        }`}
      >
        Status do pagamento: {statusMap[payStatus] || "❓ Desconhecido"}
      </p>

      <div className="succ-welcome">
        <p>
          {name}, seu acesso foi criado com sucesso. Aqui estão seus dados de
          login:
        </p>
      </div>

      <div className="succ-box">
        <div className="succ-field">
          <label>Link de acesso</label>
          <div className="succ-copy-row">
            <input
              type="text"
              value="https://dominioeletrico.com.br/logon"
              readOnly
            />
            <button
              onClick={() =>
                copyToClipboard("link", "https://dominioeletrico.com.br/logon")
              }
            >
              {copiedField === "link" ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
        </div>

        <div className="succ-field">
          <label>Usuário (email)</label>
          <div className="succ-copy-row">
            <input type="text" value={email} readOnly />
            <button onClick={() => copyToClipboard("email", email)}>
              {copiedField === "email" ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
        </div>

        <div className="succ-field">
          <label>Senha inicial</label>
          <div className="succ-copy-row">
            <input type="text" value={password} readOnly />
            <button onClick={() => copyToClipboard("password", password)}>
              {copiedField === "password" ? (
                <Check size={18} />
              ) : (
                <Copy size={18} />
              )}
            </button>
          </div>
        </div>
      </div>

      <p className="succ-note">
        <b>Observação:</b> Esta é uma senha inicial padrão gerada para sua conta.
        Caso já possuísse uma conta, use sua senha antiga.
      </p>

      <p className="succ-note">Esses dados também foram enviados para o seu email.</p>

      <p className="succ-footer">
        <i>Bons estudos!</i>
      </p>
    </div>
  );
};

export default SuccessScreen;
